import ProgressiveImageDefault from 'react-progressive-image';
import React from 'react';

// react-progressive-image is a CommonJS package. Under Vite/esbuild the default
// import can resolve to the module namespace object ({ default: fn }) instead of
// the component itself (it worked under CRA/webpack). Unwrap defensively so it
// works regardless of how the bundler interops the CJS default export.
const ProgressiveImageBase: React.ComponentType<any> =
  (ProgressiveImageDefault as any)?.default ?? ProgressiveImageDefault;

// Type wrapper for react-progressive-image (unmaintained package with outdated types for React 18)
const ProgressiveImage = ProgressiveImageBase as React.ComponentType<{
  src: string;
  placeholder: string;
  children: (src: string, loading: boolean) => React.ReactNode;
  onError?: (errorEvent?: Error | Event) => void;
}>;

export default ProgressiveImage;
